/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MatchedAllergyDto { 
    /**
     * Allergy ID
     */
    allergyId: string;
    /**
     * Element ID that matched
     */
    elementId: string;
    /**
     * Display name of the allergen
     */
    allergenDisplay: string;
    /**
     * Clinical status of the allergy
     */
    status: string;
    /**
     * Verification status element ID
     */
    verificationStatusElementId?: string;
    /**
     * Criticality element ID
     */
    criticalityElementId?: string;
    /**
     * Type of match (direct or cross-reactive)
     */
    matchType: MatchedAllergyDto.MatchTypeEnum;
    /**
     * Cross-reactivity risk percentage (if applicable)
     */
    crossReactivityRisk?: number;
    /**
     * Cross-reactive substance display name (if applicable)
     */
    crossReactiveSubstance?: string;
}
export namespace MatchedAllergyDto {
    export type MatchTypeEnum = 'direct' | 'cross-reactive';
    export const MatchTypeEnum = {
        Direct: 'direct' as MatchTypeEnum,
        CrossReactive: 'cross-reactive' as MatchTypeEnum
    };
}


